import { BodyM, Caption, Heading3, Heading5 } from '@casavo/base-ui'
import { motion } from 'framer-motion'
import Trans from 'next-translate/Trans'
import useTranslation from 'next-translate/useTranslation'
import React from 'react'
import { useInView } from 'react-intersection-observer'

import { ThisIsACasavoClaim } from '@/components/InventoryBannerBig/ThisIsACasavoClaim'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { marginBottom } from '@/shared-styles/styles.css'

import LinkArrow from '../LinkArrow'

import BannerListComponent from './BannerList'
import { bannerBackground, bannerBody, content, contentLeft } from './styles.css'

const BannerCasavoProperties: React.FC<{ onClickCta: () => void }> = ({ onClickCta }) => {
  const { t } = useTranslation()

  const { inView, ref } = useInView({
    triggerOnce: true,
  })

  const bannerAnimation = {
    hidden: {
      opacity: 0,
      y: 50,
    },
    show: {
      opacity: 1,
      y: 0,
    },
  }

  return (
    <div className={sprinkles({ marginBottom: '2xl' })}>
      <ThisIsACasavoClaim
        className={marginBottom.s}
        i18nKey="PropertyAdvantages:PropertyAdvantages_CasavoProperty_BannerIntro"
      />
      <div ref={ref} className={bannerBackground}>
        <div className={bannerBody}>
          <div className={content}>
            <div className={contentLeft}>
              <motion.div
                animate={inView ? 'show' : 'hidden'}
                className={sprinkles({ paddingBottom: { mobile: 'm', tablet: 's' } })}
                initial="hidden"
                transition={{
                  duration: 1.3,
                  type: 'tween',
                }}
                variants={bannerAnimation}
              >
                <Heading5>
                  <Trans components={[<br key="0" />]} i18nKey={'casavo-properties-banner:title_detail'} />
                </Heading5>
              </motion.div>
              <motion.div
                animate={inView ? 'show' : 'hidden'}
                className={sprinkles({ paddingBottom: { mobile: 'l', tablet: '2xl' } })}
                initial="hidden"
                transition={{
                  delay: 0.5,
                  duration: 1.3,
                  type: 'tween',
                }}
                variants={bannerAnimation}
              >
                <BodyM> {t('casavo-properties-banner:text_detail')}</BodyM>
              </motion.div>
            </div>
            <div className={sprinkles({ paddingBottom: { mobile: 'xl', tablet: 0 } })}>
              {[
                t('casavo-properties-banner:advantage_first'),
                t('casavo-properties-banner:advantage_second'),
                t('casavo-properties-banner:advantage_third'),
              ].map((item, index) => (
                <BannerListComponent key={`advantage-${index}`} title={item} />
              ))}
            </div>
          </div>
          <div className={sprinkles({ textAlign: 'center' })}>
            <LinkArrow
              data-testid={'discover_all_the_advantages'}
              fontSize={13}
              inView={inView}
              label={t('casavo-properties-banner:discover_all_the_advantages')}
              onClick={onClickCta}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default BannerCasavoProperties
